<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import { storeToRefs } from 'pinia';

import { useSessionStore } from '@/stores/useSessionStore';
import { useGhccActivityStore } from '@/stores/useGhccActivityStore';
import { useGhccIframeStore } from '@/stores/useGhccIframeStore';

import { useLDFlag } from 'launchdarkly-vue-client-sdk';

const GShareActivity = defineAsyncComponent(() => import('@/components/GShareActivity'));
const GAccessibleContentLink = defineAsyncComponent(
  () => import('@/components/GAccessibleContentLink'),
);

const hasAccessibleContentLink = useLDFlag('activity-has-accessible-content-link', false);

const { canCloseActivity, canShareActivity } = storeToRefs(useSessionStore());
const { isActivityStarted } = storeToRefs(useGhccActivityStore());
const { source } = storeToRefs(useGhccIframeStore());
</script>

<template>
  <div :class="['ghcc-wrapper', isActivityStarted && 'activity-started']">
    <GAccessibleContentLink
      v-if="hasAccessibleContentLink"
      tabindex="0"
      link="https://www.w3.org/WAI/WCAG22/quickref/?currentsidebar=%23col_overview&showtechniques=144#top"
    />
    <GShareActivity v-if="canShareActivity" tabindex="0" />
    <iframe
      id="ghcc-content"
      :src="source"
      title="Activity"
      allow="autoplay; microphone"
      allowfullscreen="true"
      tabindex="-1"
      aria-hidden="true"
    />
    <div v-if="isActivityStarted && !canCloseActivity" class="hide-close-button" />
  </div>
</template>

<style scoped lang="scss">
.ghcc-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: 0;
  opacity: 0;
  z-index: 99999;
  transition: opacity ease-in 0.5s;

  &.activity-started {
    height: 100vh;
    height: 100dvh;
    opacity: 1;
  }

  .hide-close-button {
    position: fixed;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background-color: var(--white);
    z-index: 999999;
  }
}

#ghcc-content {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
